<div class="di-confirmation-maj-app">
	<div class="dialog-content">
		<lua-action-secondaire [libelle]="'OUI, mettre à jour.'" [color]="'CouleurPrimaire'" [fullWidth]="true"
			[avecIcone]="false" [size]="'medium'" [isDisabled]="false" [positionIcone]="'L'"
			(click)="onConfirm()"></lua-action-secondaire>
		<lua-bouton-texte [libelle]="'NON, quitter l\'application.'" [color]="'CouleurPrimaire'" [fullWidth]="true" [isDisabled]="false"
			[endIcon]="''" [type]="'button'" [size]="'medium'" (click)="onCancel()"></lua-bouton-texte>
	</div>
</div>